import { refOptionsService } from "../../services";
import {
  useRefOptionsCache,
  useRefOptionsCodes,
  useRefOptionsState,
} from "./hooks";
import { RefOptionsContext } from "./RefOptionsContext";
import { RefOptionsCacheManager, RefOptionsContextService } from "./services";
import { RefOptionsProviderProps } from "./types";

const cacheManager = new RefOptionsCacheManager();
const contextService = new RefOptionsContextService(
  refOptionsService,
  cacheManager,
);

export function RefOptionsProvider({ children }: RefOptionsProviderProps) {
  const { state, dispatch } = useRefOptionsState();

  const { refreshCodes } = useRefOptionsCodes(contextService, dispatch);

  const { getOptionsByCode, clearCache } = useRefOptionsCache(
    contextService,
    dispatch,
    state,
  );

  const contextValue = {
    state,
    getOptionsByCode,
    clearCache,
    refreshCodes,
  };

  return (
    <RefOptionsContext.Provider value={contextValue}>
      {children}
    </RefOptionsContext.Provider>
  );
}
